export default "__VITE_ASSET__Dcz4sObH__"